var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13296_116919)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13296_116919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.87891 -0.117188H30.8789V25.055H-6.87891V-0.117188Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.87891 3.0293H30.8789V6.17551H-6.87891V3.0293ZM-6.87891 9.32254H30.8789V12.4688H-6.87891V9.32254ZM-6.87891 15.615H30.8789V18.7612H-6.87891V15.615ZM-6.87891 21.9082H30.8789V25.0544H-6.87891V21.9082Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.87891 -0.117188H12V13.4371H-6.87891V-0.117188Z",
    fill: "#2E52B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.482558 5.43374L0.178504 6.36913H-0.804969L-0.00917895 6.94693L-0.313233 7.88225L0.482558 7.30445L1.27783 7.88225L0.973852 6.94693L1.76964 6.36913H0.786095L0.482558 5.43374ZM0.786095 9.74462L0.482558 8.80931L0.178504 9.74462H-0.804969L-0.00917895 10.3225L-0.313233 11.2578L0.482558 10.6799L1.27783 11.2578L0.973852 10.3225L1.76964 9.74462H0.786095ZM-3.37029 9.74462L-3.6739 8.80931L-3.97795 9.74462H-4.96143L-4.16564 10.3225L-4.46969 11.2578L-3.6739 10.6799L-2.87855 11.2578L-3.18253 10.3225L-2.38689 9.74462H-3.37029ZM-3.6739 5.43374L-3.97795 6.36913H-4.96143L-4.16564 6.94693L-4.46969 7.88225L-3.6739 7.30445L-2.87855 7.88225L-3.18253 6.94693L-2.38689 6.36913H-3.37029L-3.6739 5.43374ZM0.482558 2.05811L0.178504 2.99357H-0.804969L-0.00917895 3.57144L-0.313233 4.50676L0.482558 3.92889L1.27783 4.50676L0.973852 3.57144L1.76964 2.99357H0.786095L0.482558 2.05811ZM-3.6739 2.05811L-3.97795 2.99357H-4.96143L-4.16564 3.57144L-4.46969 4.50676L-3.6739 3.92889L-2.87855 4.50676L-3.18253 3.57144L-2.38689 2.99357H-3.37029L-3.6739 2.05811ZM4.63894 5.43374L4.33496 6.36913H3.35149L4.1472 6.94693L3.8433 7.88225L4.63894 7.30445L5.43436 7.88225L5.13031 6.94693L5.9261 6.36913H4.94262L4.63894 5.43374ZM4.94262 9.74462L4.63894 8.80931L4.33496 9.74462H3.35149L4.1472 10.3225L3.8433 11.2578L4.63894 10.6799L5.43436 11.2578L5.13031 10.3225L5.9261 9.74462H4.94262ZM9.09908 9.74462L8.79547 8.80931L8.49142 9.74462H7.50802L8.30366 10.3225L7.99968 11.2578L8.79547 10.6799L9.59082 11.2578L9.28677 10.3225L10.0826 9.74462H9.09908ZM8.79547 5.43374L8.49142 6.36913H7.50802L8.30366 6.94693L7.99968 7.88225L8.79547 7.30445L9.59082 7.88225L9.28677 6.94693L10.0826 6.36913H9.09908L8.79547 5.43374ZM4.63894 2.05811L4.33496 2.99357H3.35149L4.1472 3.57144L3.8433 4.50676L4.63894 3.92889L5.43436 4.50676L5.13031 3.57144L5.9261 2.99357H4.94262L4.63894 2.05811ZM8.79547 2.05811L8.49142 2.99357H7.50802L8.30366 3.57144L7.99968 4.50676L8.79547 3.92889L9.59082 4.50676L9.28677 3.57144L10.0826 2.99357H9.09908L8.79547 2.05811Z",
    fill: "#F0F0F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13296_116919"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.46875,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13296_116919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.7578,
    height: 37.7578,
    fill: "white",
    transform: "translate(-6.87891 -6.41016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdFlag);
export default __webpack_public_path__ + "static/media/usd-flag.03a2f889bda271d23aa04e2d83203691.svg";
export { ForwardRef as ReactComponent };